import N from "@babel/runtime/helpers/esm/slicedToArray";
import W from "@babel/runtime/helpers/esm/objectWithoutProperties";
import h from "@babel/runtime/helpers/esm/objectSpread2";
import L from "@babel/runtime/helpers/esm/classCallCheck";
import z from "@babel/runtime/helpers/esm/createClass";
import u from "@babel/runtime/helpers/esm/assertThisInitialized";
import C from "@babel/runtime/helpers/esm/inherits";
import A from "@babel/runtime/helpers/esm/createSuper";
import o from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as q } from "@semcore/utils/lib/core/index";
import B, { sstyled as y, assignProps as I, Component as D } from "@semcore/core";
import g from "react";
import { Box as p } from "@semcore/flex-box";
import k from "@semcore/neighbor-location";
import H from "@semcore/utils/lib/enhances/keyboardFocusEnhance";
import G from "@semcore/utils/lib/enhances/resolveColorEnhance";
import J, { inputProps as O } from "@semcore/utils/lib/inputProps";
import { inputProps as P_ } from "@semcore/utils/lib/inputProps";
import { callAllEventHandlers as T } from "@semcore/utils/lib/assignProps";
import Q from "@semcore/utils/lib/uniqueID";
import "@semcore/utils/lib/canUseDOM";
var Y = ["Children", "forwardRef", "styles", "includeInputProps", "keyboardFocused", "neighborLocation", "theme", "uid", "active", "resolveColor"], Z = (
  /*__reshadow_css_start__*/
  (q.insert(
    /*__inner_css_start__*/
    ".___SSwitch_utncw_gg_{display:inline-flex;vertical-align:middle;align-items:center;position:relative;-webkit-user-select:none;-moz-user-select:none;user-select:none}.___SSwitch_utncw_gg_.__size_utncw_gg_ .___SToggle_utncw_gg_{border-radius:var(--intergalactic-switch-rounded, 24px)}.___SSwitch_utncw_gg_._size_m_utncw_gg_{font-size:var(--intergalactic-fs-100, 12px);line-height:var(--intergalactic-lh-100, 133%)}.___SSwitch_utncw_gg_._size_m_utncw_gg_ .___SToggle_utncw_gg_{width:20px;height:12px;min-width:20px}.___SSwitch_utncw_gg_._size_m_utncw_gg_ .___SSlider_utncw_gg_{width:8px;height:8px;border-radius:4px}.___SSwitch_utncw_gg_._size_l_utncw_gg_{font-size:var(--intergalactic-fs-200, 14px);line-height:var(--intergalactic-lh-200, 142%)}.___SSwitch_utncw_gg_._size_l_utncw_gg_ .___SToggle_utncw_gg_{height:20px;width:36px;min-width:36px}.___SSwitch_utncw_gg_._size_l_utncw_gg_ .___SSlider_utncw_gg_{width:16px;height:16px;border-radius:8px}.___SSwitch_utncw_gg_._size_xl_utncw_gg_{font-size:var(--intergalactic-fs-300, 16px);line-height:var(--intergalactic-lh-300, 150%)}.___SSwitch_utncw_gg_._size_xl_utncw_gg_ .___SToggle_utncw_gg_{width:44px;height:24px;min-width:44px}.___SSwitch_utncw_gg_._size_xl_utncw_gg_ .___SSlider_utncw_gg_{width:20px;height:20px;border-radius:10px}.___SSwitch_utncw_gg_.__disabled_utncw_gg_{opacity:var(--intergalactic-disabled-opacity, 0.3)}.___SSwitch_utncw_gg_.__disabled_utncw_gg_ .___SAddon_utncw_gg_,.___SSwitch_utncw_gg_.__disabled_utncw_gg_ .___SToggle_utncw_gg_{cursor:default}.___SSlider_utncw_gg_,.___SToggle_utncw_gg_{display:flex;align-items:center;justify-content:space-around}.___SToggle_utncw_gg_{background:var(--intergalactic-control-switch-bg, #a9abb6);position:relative;color:var(--intergalactic-icon-secondary-neutral, #a9abb6);cursor:pointer}.___SToggle_utncw_gg_.__checked_utncw_gg_._theme_info_utncw_gg_{color:var(--intergalactic-control-primary-info, #008ff8);background-color:var(--intergalactic-control-primary-info, #008ff8)}.___SToggle_utncw_gg_.__checked_utncw_gg_._theme_success_utncw_gg_{color:var(--intergalactic-control-primary-success, #009f81);background-color:var(--intergalactic-control-primary-success, #009f81)}.___SToggle_utncw_gg_.__checked_utncw_gg_._theme_custom_utncw_gg_{color:var(--color_utncw);background-color:var(--color_utncw)}.___SToggle_utncw_gg_.__keyboardFocused_utncw_gg_{box-shadow:var(--intergalactic-keyboard-focus, 0px 0px 0px 3px rgba(0, 143, 248, 0.5))}.___SToggle_utncw_gg_._neighborLocation_left_utncw_gg_{margin-left:var(--intergalactic-spacing-2x, 8px)}.___SToggle_utncw_gg_._neighborLocation_both_utncw_gg_{margin-right:var(--intergalactic-spacing-2x, 8px);margin-left:var(--intergalactic-spacing-2x, 8px)}.___SToggle_utncw_gg_._neighborLocation_right_utncw_gg_{margin-right:var(--intergalactic-spacing-2x, 8px)}.___SSlider_utncw_gg_{background:var(--intergalactic-bg-primary-neutral, #ffffff);transform:translateX(-50%) scaleX(1);transition:transform calc(var(--intergalactic-duration-switch, 100)*1ms) ease-in-out;pointer-events:none}.___SSlider_utncw_gg_.__checked_utncw_gg_{transform:translateX(50%) scaleX(1)}.___SToggle_utncw_gg_.__active_utncw_gg_ .___SSlider_utncw_gg_{transform:translateX(-50%) scaleX(1.15) translateX(1px)}.___SToggle_utncw_gg_.__active_utncw_gg_ .___SSlider_utncw_gg_.__checked_utncw_gg_{transform:translateX(50%) scaleX(1.15) translateX(-1px)}.___SInput_utncw_gg_{position:absolute;clip:rect(1px,1px,1px,1px)}.___SAddon_utncw_gg_{cursor:pointer}.___SAddon_utncw_gg_._neighborLocation_right_utncw_gg_{color:var(--intergalactic-text-primary, #191b23)}.___SAddon_utncw_gg_._neighborLocation_left_utncw_gg_,.___SSwitch_utncw_gg_.__checked_utncw_gg_ .___SAddon_utncw_gg_._neighborLocation_right_utncw_gg_{color:var(--intergalactic-text-secondary, #6c6e79)}.___SAddon_utncw_gg_._neighborLocation_left_utncw_gg_:nth-child(2){color:var(--intergalactic-text-primary, #191b23)}.___SSwitch_utncw_gg_.__checked_utncw_gg_ .___SAddon_utncw_gg_._neighborLocation_right_utncw_gg_:nth-last-child(2){color:var(--intergalactic-text-primary, #191b23)}.___SSwitch_utncw_gg_.__checked_utncw_gg_ .___SAddon_utncw_gg_._neighborLocation_left_utncw_gg_{color:var(--intergalactic-text-primary, #191b23)}@media (prefers-reduced-motion){.___SSlider_utncw_gg_{transition:none}}",
    "utncw_gg_"
  ), {
    __SSwitch: "___SSwitch_utncw_gg_",
    __SToggle: "___SToggle_utncw_gg_",
    _checked: "__checked_utncw_gg_",
    _theme_info: "_theme_info_utncw_gg_",
    _theme_success: "_theme_success_utncw_gg_",
    _theme_custom: "_theme_custom_utncw_gg_",
    "--color": "--color_utncw",
    _keyboardFocused: "__keyboardFocused_utncw_gg_",
    _neighborLocation_left: "_neighborLocation_left_utncw_gg_",
    _neighborLocation_both: "_neighborLocation_both_utncw_gg_",
    _neighborLocation_right: "_neighborLocation_right_utncw_gg_",
    __SInput: "___SInput_utncw_gg_",
    __SAddon: "___SAddon_utncw_gg_",
    __SSlider: "___SSlider_utncw_gg_",
    _size: "__size_utncw_gg_",
    _size_m: "_size_m_utncw_gg_",
    _size_l: "_size_l_utncw_gg_",
    _size_xl: "_size_xl_utncw_gg_",
    _disabled: "__disabled_utncw_gg_",
    _active: "__active_utncw_gg_"
  })
);
function __(a) {
  return !["info", "success"].includes(a);
}
var w = /* @__PURE__ */ function(a) {
  C(i, a);
  var s = A(i);
  function i(e) {
    var _;
    return L(this, i), _ = s.call(this, e), o(u(_), "inputRef", /* @__PURE__ */ g.createRef()), o(u(_), "state", {
      active: !1
    }), o(u(_), "handleMouseUp", function() {
      _.setState({
        active: !1
      });
    }), o(u(_), "handleMouseDown", function(t) {
      (t == null ? void 0 : t.button) === 0 && _.setState({
        active: !0
      });
    }), _.forceUpdate = _.forceUpdate.bind(u(_)), _;
  }
  return z(i, [{
    key: "getValueProps",
    value: function() {
      var _ = this.asProps, t = _.theme, n = _.uid, c = this.state.active;
      return {
        theme: t,
        ref: this.inputRef,
        $rootForceUpdate: this.forceUpdate,
        uid: n,
        active: c
      };
    }
  }, {
    key: "getAddonProps",
    value: function() {
      var _ = this.asProps.uid;
      return {
        uid: _
      };
    }
  }, {
    key: "render",
    value: function() {
      var _ = this.asProps, t, n, c = p, r = this.asProps, f = r.Children, S = r.styles, v = r.controlsLength, b = (n = this.inputRef.current) === null || n === void 0 ? void 0 : n.checked;
      return t = y(S), /* @__PURE__ */ g.createElement(c, t.cn("SSwitch", h({}, I({
        tag: "label",
        checked: b,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp
      }, _))), /* @__PURE__ */ g.createElement(k, t.cn("NeighborLocation", {
        controlsLength: v
      }), /* @__PURE__ */ g.createElement(f, t.cn("Children", {}))));
    }
  }]), i;
}(D);
o(w, "displayName", "Switch");
o(w, "style", Z);
o(w, "enhance", [Q()]);
o(w, "defaultProps", {
  theme: "info",
  size: "m"
});
var m = /* @__PURE__ */ function(a) {
  C(i, a);
  var s = A(i);
  function i() {
    var e;
    L(this, i);
    for (var _ = arguments.length, t = new Array(_), n = 0; n < _; n++)
      t[n] = arguments[n];
    return e = s.call.apply(s, [this].concat(t)), o(u(e), "timer", null), o(u(e), "handleKeyDown", function(c) {
      (c.key === "Enter" || c.key === " ") && (c.preventDefault(), e.handlers.checked(!e.asProps.checked, c));
    }), o(u(e), "handlerInputClick", function(c) {
      return c.stopPropagation();
    }), e;
  }
  return z(i, [{
    key: "uncontrolledProps",
    value: function() {
      var _ = this;
      return {
        checked: [function(t) {
          return t.target.checked;
        }, function() {
          clearTimeout(_.timer), _.timer = setTimeout(function() {
            _.asProps.$rootForceUpdate();
          }, 0);
        }]
      };
    }
  }, {
    key: "componentDidMount",
    value: function() {
      this.asProps.$rootForceUpdate();
    }
  }, {
    key: "componentDidUpdate",
    value: function(_) {
      var t = _.checked;
      t !== void 0 && t !== this.asProps.checked && this.asProps.$rootForceUpdate();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function() {
      var _ = this, t = p, n = p, c = p, r = this.asProps, f = r.Children, S = r.forwardRef, v = r.styles, b = r.includeInputProps, E = r.keyboardFocused, U = r.neighborLocation, x = r.theme;
      r.uid;
      var F = r.active, $ = r.resolveColor, X = W(r, Y), R = J(X, b), P = N(R, 2), l = P[0], M = P[1], K = __(x) ? "custom" : x, V = $(x);
      return /* @__PURE__ */ g.createElement(k.Detect, {
        neighborLocation: U
      }, function(j) {
        var d;
        return d = y(v), /* @__PURE__ */ g.createElement(t, d.cn("SToggle", h({
          keyboardFocused: E,
          neighborLocation: j,
          checked: l.checked,
          active: F,
          "use:theme": K,
          "use:color": V
        }, M)), /* @__PURE__ */ g.createElement(n, d.cn("SInput", h(h({
          tag: "input",
          type: "checkbox",
          ref: S,
          role: "switch",
          "aria-readonly": l.disabled
        }, l), {}, {
          onClick: T(_.handlerInputClick, l.click),
          onKeyDown: T(_.handleKeyDown, l.onKeyDown)
        }))), /* @__PURE__ */ g.createElement(c, d.cn("SSlider", {
          checked: l.checked
        }), /* @__PURE__ */ g.createElement(f, d.cn("Children", {}))));
      });
    }
  }]), i;
}(D);
o(m, "hoistProps", ["checked", "disabled"]);
o(m, "enhance", [H(), G()]);
o(m, "defaultProps", {
  includeInputProps: O,
  defaultChecked: !1
});
function t_(a) {
  var s = arguments[0], i = p, e = a.styles, _ = a.neighborLocation, t = a.uid;
  return /* @__PURE__ */ g.createElement(k.Detect, {
    neighborLocation: _
  }, function(n) {
    var c;
    return c = y(e), /* @__PURE__ */ g.createElement(i, c.cn("SAddon", h({}, I({
      tag: "span",
      neighborLocation: n,
      id: "igc-".concat(t, "-switch-addon-").concat(n)
    }, s))));
  });
}
const x_ = B(w, {
  Value: m,
  Addon: t_
});
export {
  x_ as default,
  P_ as inputProps
};
